export default function EcoCredits(props: any) {
    return (
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M22.9181 15.8645C23.1734 14.9913 23.3101 14.0688 23.3101 13.1148C23.3101 7.63209 18.7943 3.1875 13.2239 3.1875C7.65344 3.1875 3.1377 7.63209 3.1377 13.1148C3.1377 18.5975 7.65344 23.042 13.2239 23.042C14.3092 23.042 15.3544 22.8733 16.334 22.5611"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
            <path
                d="M24.5003 19.2507C24.5003 19.895 23.1945 20.4173 21.5837 20.4173C19.9728 20.4173 18.667 19.895 18.667 19.2507C18.667 18.6063 19.9728 18.084 21.5837 18.084C23.1945 18.084 24.5003 18.6063 24.5003 19.2507Z"
                fill="white"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M24.1092 20.418C23.6048 20.7667 22.6623 21.0013 21.5827 21.0013C20.5031 21.0013 19.5605 20.7667 19.0562 20.418C18.808 20.5896 18.666 20.7888 18.666 21.0013C18.666 21.6456 19.9719 22.168 21.5827 22.168C23.1935 22.168 24.4993 21.6456 24.4993 21.0013C24.4993 20.7888 24.3573 20.5896 24.1092 20.418Z"
                fill="white"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M24.1092 22.168C23.6048 22.5167 22.6623 22.7513 21.5827 22.7513C20.5031 22.7513 19.5605 22.5167 19.0562 22.168C18.808 22.3396 18.666 22.5388 18.666 22.7513C18.666 23.3956 19.9719 23.918 21.5827 23.918C23.1935 23.918 24.4993 23.3956 24.4993 22.7513C24.4993 22.5388 24.3573 22.3396 24.1092 22.168Z"
                fill="white"
            />
            <path
                d="M8.56934 11.3672H12.6669M8.56934 16.0083H12.6669M14.558 11.3672H18.6555M8.56934 13.7505H12.6669M14.558 16.1696V14.0656C14.558 13.8916 14.6991 13.7505 14.8732 13.7505H18.6555"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
        </svg>
    );
}
